module.exports = __webpack_public_path__ + "909d6427a96d9a42b92c4cf6b923b672.pdf";